<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox row">
      <div class="ibox-title">
        <button data-toggle="modal" data-target="#add-pbn" v-if="user.admin" class="btn btn-xs btn-primary pull-right">
          <i class="fa fa-plus"></i> Add Pbn
        </button>
        <h5>Pbns</h5>
      </div>
        <div class="ibox-content col-lg-12">
          <filters></filters>
          <div class="col-lg-12 m-t-sm"></div>
          <results></results>
        </div>
    </div>
  </div>
</template>
<script>
import List from './List'
import Filters from './Filters'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      moto: 'Pbns ftw!'
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      user: 'getUser'
    }),
    filtersOptions () {
      return this.f.userData.filters
    }
  },
  mounted () {
    document.title = 'PBNS :: PBN360 by Aphex Media'
  },
  components: {
    results: List,
    filters: Filters
  }
}
</script>
<style>
.green {
  color: green;
}
.orange {
  color: orange;
}
.red {
  color: red;
}
#custom-saved-filters .dropdown-toggle {
  padding: 0;
}
#custom-saved-filters input[type=search]{
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Pbns.vue